import { Maybe } from 'types/UtilityTypes';
import {
  GenericSuggestion,
  SuggestionPipelines,
} from 'types/suggestions/CoreSuggestions';

// Whether opening `suggestion` should be reported to the backend. Only called
// from LoadBuildingTab, which mounts exactly when the Load Building tab becomes
// visible, so true means that tab is showing this load-building suggestion.
//
// Callers derive the suggestion id from this and use that id as the effect
// dependency, so the report fires once per id with no ref tracking what was
// already sent. Selections from other pipelines collapse to no id, so a Quick
// Quote id — which comes from a different table and can collide numerically —
// can never be mistaken for a load-building one.
export function shouldRecordLoadBuildingSuggestionOpened(
  suggestion: Maybe<GenericSuggestion>
): suggestion is GenericSuggestion {
  if (!suggestion) {
    return false;
  }
  if (suggestion.pipeline !== SuggestionPipelines.LoadBuilding) {
    return false;
  }
  // Only positive DB ids are postable: locally built suggestions use 0 until the
  // backend assigns one, and synthetic SharePoint rows use negative ids. The
  // endpoint takes a uint and rejects both. Deliberately duplicated rather than
  // shared with suggestionIdForCreateLoadApi: importing from loadInfoAndBuilding
  // pulls that file into the Conventions job's changed-file scope, where it has
  // pre-existing violations unrelated to this change.
  if (!Number.isFinite(suggestion.id) || suggestion.id <= 0) {
    return false;
  }
  return true;
}
